import CommentService from '@/services/CommentService';
import PostService from "@/services/PostService";
import Vue from 'vue';
const {
  $gettext
} = Vue.prototype;
// state
const localState = () => ({
  isShowPopupReport: false,
  reportData: {}
});

// type: 1: post , 2: comment
const localGetters = {

}

// mutations
const mutations = {
  'SET_STATUS_POPUP'(state, status) {
    state.isShowPopupReport = status;
  },
  'SET_REPORT'(state, data) {
    state.isShowPopupReport = true;
    state.reportData = {...data}
    console.log("comment", state.reportData);
  }
};
const actions = {
  setStatusPopup({
    commit
  }, status) {
    commit("SET_STATUS_POPUP", status);
  },
  setReport({
    commit
  }, data) {
    commit("SET_REPORT", data);
  },

  async reportRequest({}, data) {
    const result = await PostService.report(data);
    console.log(result)
    return true;
  },

}
export default {
  state: localState(),
  mutations,
  getters: localGetters,
  actions
};